import React, { FC, useState } from "react"
import { observer } from "mobx-react"
import { Tabs, Spin } from "antd"
import { useStore } from "stores/utils/use-store"
import { CountryGroupsTable } from "./country-groups-table"
import { CountryMultipliersTable } from "./country-multipliers-table"

const { TabPane } = Tabs

export const CountryGroupsPage: FC = observer(() => {
  const { dataStore: { countryGroupsStore } } = useStore()
  const [activeTab, setActiveTab] = useState<string>("groups")

  return (
    <Spin spinning={countryGroupsStore.isLoading} size="large">
      <Tabs
        style={{ marginBottom: "20px" }}
        activeKey={activeTab}
        onChange={setActiveTab}
      >
        <TabPane tab="Country Groups" key="groups">
          <CountryGroupsTable />
        </TabPane>
        <TabPane tab="Multipliers" key="multipliers">
          <CountryMultipliersTable />
        </TabPane>
      </Tabs>
    </Spin>
  )
})
